import { VStack } from '@rbilabs/universal-components';

import Picture from 'components/picture';
import { withTypography } from 'components/ui';
import { primitive } from 'styles/constants';

export const CallToActionHeaderContainer = VStack;

export const CallToActionHeading = withTypography({
  variant: 'headerTwo',
  textAlign: 'center',
  mt: '$4',
});

export const CallToActionSubheading = withTypography({
  variant: 'headerThree',
  textAlign: 'center',
  color: primitive.$fieryRed,
  style: { fontWeight: '400' },
});

export const CallToActionBody = withTypography({ mb: '$8' });

export const Image = Picture.withConfig({
  width: '66%',
  objectFitContain: true,
  marginX: 'auto',
});

export const CallsToAction = VStack.withConfig({
  width: '90%',
  maxWidth: '920px',
  marginTop: '0',
  marginX: 'auto',
  space: '$16',
  marginBottom: '$16',
});

export const CallToAction = VStack.withConfig({
  width: '100%',
});
